import { useState } from 'react'
import { fmtMoney } from '../lib/pricing'

// Pick a service + a bag count, then it is created server-side and joins the
// pickup as its own order. No price is entered here: the new order is weighed
// like any other, through the one pricing engine.
//
// Shared by the single ticket (where it turns a lone order into a pickup of
// two) and the grouped ticket (where it adds a third).
export default function ServicePicker({ services, busy, onCancel, onPick }) {
  const [serviceId, setServiceId] = useState('')
  const [bags, setBags] = useState('1')
  const picked = services.find((s) => s.id === serviceId) || null

  if (services.length === 0) {
    return (
      <div className="text-[12px] text-ink-2">
        Every service is already on this pickup.
        <button type="button" onClick={onCancel} className="ml-2 font-extrabold text-navy underline">
          Close
        </button>
      </div>
    )
  }

  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="text-[10px] font-bold uppercase tracking-wider text-ink-2">Add a service</div>
        <button type="button" onClick={onCancel} className="text-[11px] font-extrabold text-navy underline">
          Cancel
        </button>
      </div>

      <div className="mt-2 flex flex-col gap-1.5">
        {services.map((s) => (
          <button
            type="button"
            key={s.id}
            onClick={() => setServiceId(s.id)}
            aria-pressed={s.id === serviceId}
            className={`flex min-h-[40px] items-center justify-between rounded-[10px] border-[1.5px] px-3 py-2 text-left transition ${
              s.id === serviceId ? 'border-navy bg-navy text-white' : 'border-line bg-white text-navy'
            }`}
          >
            <span className="font-bricolage text-[13px] font-extrabold">{s.name}</span>
            <span className={`text-[11px] ${s.id === serviceId ? 'text-white/75' : 'text-ink-2'}`}>
              {s.pricing_mode === 'per_item' ? 'per item' : fmtMoney(s.base_price_cents)}
            </span>
          </button>
        ))}
      </div>

      {picked && picked.pricing_mode !== 'per_item' && (
        <div className="mt-3">
          <label className="field-label">How many bags</label>
          <input
            type="number"
            inputMode="numeric"
            min="1"
            max="9"
            value={bags}
            onChange={(e) => setBags(e.target.value)}
            className="field-input"
          />
        </div>
      )}

      <button
        type="button"
        onClick={() => picked && onPick(picked, Math.max(1, Number(bags) || 1))}
        disabled={!picked || busy}
        className={`mt-3 w-full rounded-xl bg-navy px-3 py-2.5 font-bricolage text-[13px] font-extrabold text-white ${
          !picked || busy ? 'opacity-50' : ''
        }`}
      >
        {busy ? 'Adding…' : picked ? `Add ${picked.name}` : 'Pick a service'}
      </button>
      <p className="mt-1.5 text-center text-[10px] leading-relaxed text-ink-3">
        It joins this pickup as its own order — own weight, own line on the invoice.
      </p>
    </div>
  )
}
